var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M25 0c13.807 0 25 11.193 25 25S38.807 50 25 50 0 38.807 0 25 11.193 0 25 0zm11.861 10.833H13.137c-.812 0-1.47.665-1.47 1.484v23.915c0 .819.659 1.483 1.472 1.483H25.91V27.319h-3.463V23.25h3.463v-2.994c0-3.473 2.103-5.363 5.176-5.363 1.472 0 2.737.11 3.106.16v3.63h-2.12c-1.671 0-1.995.8-1.995 1.976v2.591h3.998l-.521 4.07h-3.477v10.395h6.783c.765 0 1.394-.589 1.466-1.34l.006-.144V12.316c0-.819-.659-1.483-1.472-1.483z"}));
}

FacebookInline.defaultProps = {"width":"50","height":"50"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
